import type { FunctionComponent } from 'react'

import { CalendarToday } from '@monthio/icons'
import { MenuItem, TextInputField } from '@monthio/react-components'
import dayjs from 'dayjs'
import i18next from 'i18next'
import styled from 'styled-components'

const StyledTextInputField = styled(TextInputField)`
	.MuiSelect-icon {
		display: none;
	}

	.MuiInputBase-root {
		height: 35px;
		width: 85px;
		font-size: 14px;
	}

	.MuiSelect-root {
		padding: 0;
	}

	.MuiSelect-selectMenu {
		text-overflow: unset;
	}

	.MuiOutlinedInput-root {
		padding: 8px;
	}
`

export interface MonthPickerProps {
	handleChange: (value: string) => void
	isDisabled?: boolean
	label?: string
	month?: number
	options: Date[]
	year?: number
}

const formatMonth = (date: dayjs.Dayjs) =>
	i18next.t('datetime', {
		formatParams: {
			val: { month: 'short', year: '2-digit' },
		},
		val: date,
	})

export const MonthPicker: FunctionComponent<MonthPickerProps> = ({
	handleChange,
	month,
	options,
	year,
}) => {
	const generatePeriodValue = () => `${year}-${String(month).padStart(2, '0')}`

	const generatePastYearOptions = () =>
		options.map((date) => {
			const dayjsDate = dayjs(date)
			return {
				displayValue: formatMonth(dayjsDate),
				value: `${dayjsDate.year()}-${String(dayjsDate.month() + 1).padStart(2, '0')}`,
			}
		})

	return (
		<StyledTextInputField
			value={generatePeriodValue()}
			onChange={(e) => handleChange(e.target.value)}
			select
			size="small"
			InputProps={{
				disableUnderline: true,
				endAdornment: <CalendarToday />,
			}}
			variant="outlined"
		>
			{generatePastYearOptions().map((option) => (
				<MenuItem key={option.value} value={option.value}>
					{option.displayValue}
				</MenuItem>
			))}
		</StyledTextInputField>
	)
}

export const generateRelevantMonths = (): Date[] => {
	const today = new Date()
	const months: Date[] = []

	for (let i = 0; i < 13; i++) {
		const date = new Date(today.getFullYear(), today.getMonth() - i, 1)
		months.push(date)
	}

	return months
}
